// Xodim profili (pages/people/PersonPage.tsx), en — manba
export default {
  noAccess: "Profile not available",
  noAccessDesc: "This person is outside your branch, or the profile does not exist.",
  breadcrumb: "People",
  tabs: { overview: "Overview", drivers_one: "Drivers ({{count}})", drivers_other: "Drivers ({{count}})", pay: "Salary & bonuses", activity: "Activity" },
  unblocked: "{{name}} unblocked",
  username: "Username",
  blocked: "Blocked",
  you: "You",
  noBranch: "No branch",
  manager: "Manager:",
  since: "In the system since {{date}}",
  lastLogin: "last sign-in {{when}}",
  neverLoggedIn: "never signed in",
  twofaOn: "2FA on",
  showDrivers: "Show drivers",
  unblock: "Unblock",
  block: "Block",
  results: "Results · {{month}}",
  kpi: {
    hires: "Hires (approved)",
    prev: "previous month: {{count}}",
    submitted: "Submitted to carriers",
    waitingReply_one: "{{count}} waiting for a reply",
    waitingReply_other: "{{count}} waiting for a reply",
    newDrivers: "New drivers",
    calls: "Calls",
    activities_one: "{{count}} activity in total",
    activities_other: "{{count}} activities in total",
    inPipeline: "In pipeline now",
    pendingHires_one: "{{count}} hire waits for approval",
    pendingHires_other: "{{count}} hires wait for approval",
    timeToHire: "Avg time to hire",
    prevValue: "previous month: {{value}}",
    retention30: "30-day retention",
    overdue: "Overdue tasks",
    overdueSub: "needs attention",
    noOverdue: "all on time",
  },
  trend: { title: "Last 6 months", subtitle: "submitted and approved hires per month", submitted: "Submitted", hires: "Hires" },
  rank: "place in {{branch}} by hires · of {{of}}",
  bonus: { supplement: "extra", title: "Bonus this month", basis: "hires: {{hires}} · stayed 30 days: {{retained}}", estimate: "estimate" },
  pipeline: { title: "Pipeline now", subtitle_one: "{{count}} active driver", subtitle_other: "{{count}} active drivers" },
  funnel: { title: "Funnel this month", subtitle: "how many drivers reached each stage" },
  retention: { title: "Retention", subtitle: "hired drivers still working after N days" },
  drivers: {
    empty: "No drivers",
    emptyDesc: "This person does not own any active drivers.",
    hint_one: "{{count}} driver · right-click a row for actions",
    hint_other: "{{count}} drivers · right-click a row for actions",
    openList: "Open in Drivers",
    cols: { name: "Name", phone: "Phone", state: "State", status: "Status", lastContact: "Last contact", nextAction: "Next action" },
  },
  pay: {
    chartTitle: "Pay by month",
    chartSubtitle: "salary and bonus, last 6 months",
    salary: "Salary",
    bonus: "Bonus",
    total12: "Paid in the last 12 months",
    total12Sub: "salaries and bonuses on record",
    unpaidSub: "{{amount}} more is not paid yet",
    salaries: "Salaries",
    noSalaries: "No salary records yet.",
    bonuses: "Bonuses",
    noBonuses: "No bonuses yet.",
    cols: { month: "Month", amount: "Amount", status: "Status", paidOn: "Paid on" },
    paid: "Paid",
    unpaid: "Not paid",
    monthTitle: "Salary and bonus · {{month}}",
    monthHint: "the month is chosen at the top of the page",
    notSet: "Not set",
    paidOn: "Paid {{date}}",
    lastMonth: "last month: {{amount}}",
    setSalary: "Set salary",
    changeAmount: "Change amount",
    markPaid: "Mark as paid",
    markUnpaid: "Mark as unpaid",
    paidLocked: "Only the owner can reopen a paid salary",
    amount: "Amount",
    note: "Note",
    notePlaceholder: "Note, e.g. bank transfer",
    salarySaved: "Salary saved · {{name}}",
    markedPaid: "Marked as paid · {{name}}",
    markedUnpaid: "Marked as unpaid · {{name}}",
    bonusNone: "Not calculated",
    bonusEstimate_one: "So far about {{amount}} · {{count}} hire",
    bonusEstimate_other: "So far about {{amount}} · {{count}} hires",
    calculateInBudget: "Calculate in Budget → Bonuses",
    adjust: "Adjust",
    approve: "Approve",
    adjustment: "Adjustment (+ or −)",
    adjustmentReason: "Reason, e.g. referral",
    calculated: "Calculated by the rule: {{amount}}",
    calcLine: "calculated {{calculated}} · adjustment {{adjustment}}",
    bonusAdjusted: "Bonus adjusted · {{name}}",
    bonusApproved: "Bonus approved · {{name}}",
    bonusPaid: "Bonus marked as paid · {{name}}",
  },
  activity: {
    title: "Recent activity",
    subtitle: "calls and notes this person wrote",
    empty: "No activity yet",
    emptyDesc: "Calls and notes this person logs on drivers appear here.",
    minutes: "{{count}} min",
  },
  list: {
    title: "People", team: "Team",
    subtitle_one: "{{count}} person · {{period}}", subtitle_other: "{{count}} people · {{period}}",
    activity: { label: "Activity", all: "Any activity", quiet_one: "Quiet {{count}}+ day", quiet_other: "Quiet {{count}}+ days", never: "Never active" },
    newUser: "New user", search: "Search by name or username", showBlocked: "Show blocked",
    roles: { all: "Everyone", recruiter: "Recruiters", branch_manager: "Managers", owner: "Owner" },
    cols: { person: "Person", scope: "Branch", drivers: "Active drivers", new: "New", submitted: "Submitted", hired: "Hired", conv: "Conv.", calls: "Calls", last: "Last activity", overdue: "Overdue" },
    empty: "Nobody matches these filters.", never: "No activity yet", blocked: "Blocked", hint: "Row opens the person's page. Period results are counted from the status history.",
  },
};
